import { withProps } from '@cast/design-system';

import { MetricsBox } from 'components/boxes';

export const SmallMetricsBox = withProps(
  MetricsBox,
  {
    titleProps: {
      variant: 'L10R',
      noWrap: true,
    },
    primaryValueProps: {
      variant: 'h6',
      color: 'textPrimary',
      noWrap: true,
    },
    secondaryValueProps: {
      variant: 'L12R',
      color: 'textSecondary',
      component: 'span',
    },
  },
  true
);

export const LargeMetricsBox = withProps(
  SmallMetricsBox,
  {
    valuesContainerProps: {
      paddingLeft: '14px',
    },
    titleProps: {
      variant: 'L12R',
      noWrap: true,
    },
  },
  true
);
